export const LISTE_PAYS = {
  title: 'Liste des pays',
  breadcrumb: {
    parametrage: 'Paramétrage',
    liste: 'Liste des pays',
  },
  actions: {
    add: 'Ajouter un pays',
    paysArchive: 'Afficher les pays archivés ({nbre})',
    masquerpaysArchiver: 'Masquer les pays archivés ({nbre})',
    search: 'Rechercher',
  },
  tab: {
    nom: 'Nom',
    normePTT: 'Norme PTT',
    normeISO: 'Norme ISO',
    actif: 'Actif',
  },
  popUp: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver cet pays ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver cet pays ?',
    titleSupprimer: 'Êtes-vous sûr de vouloir supprimer ce pays ?',
  },
  messages: {
    success: {
      archiver: 'pays archivé avec succès.',
      desarchiver: 'pays désarchivé avec succès.',
      supprimer: 'Le pays a été supprimé',
    },
  },
};

export const ADD_PAYS = {
  titleAdd: 'Ajouter un pays',
  titleEdit: 'Modifier un pays',
  information: {
    libelle: 'Libellé',
    modulepays: 'Module pays',
    color: 'Couleur',
  },
  informationPays: {
    nom: 'Nom',
    normePTT: 'Norme PTT',
    normeISO: 'Norme ISO',
  },
  success: {
    add: 'Le pays a été ajouté avec succès.',
    edit: 'Le pays a été modifié avec succès.',
  },
  error: {
    nom: 'Nom',
    normePTT: 'Norme PTT',
    normeISO: 'Norme ISO',
  },
};
